/**
 * Aufbewahrung im Papierkorb (F-45). Rein; gerechnet wird in Millisekunden
 * auf UTC-Zeitpunkten, deshalb ohne date-fns.
 */
import { AUFBEWAHRUNG_TAGE, type PapierkorbEintrag } from '@/domain/papierkorb/typen';

const TAG_MS = 86_400_000;

const ms = (jetzt: Date | number) => (typeof jetzt === 'number' ? jetzt : jetzt.getTime());

/** Alles, was vor diesem Zeitpunkt geloescht wurde, ist abgelaufen. */
export function ablaufGrenze(jetzt: Date | number, tage = AUFBEWAHRUNG_TAGE): string {
  return new Date(ms(jetzt) - tage * TAG_MS).toISOString();
}

/**
 * Wann ein Eintrag endgueltig verschwindet (derselbe Zeitpunkt wie in
 * `ablaufGrenze`). Die Woerter „heute“/„morgen“ dazu rechnet die Oberflaeche
 * nach Kalendertagen (`modules/papierkorb/liste.ts`).
 */
export function ablaufAm(geloeschtAm: string, tage = AUFBEWAHRUNG_TAGE): Date {
  return new Date(Date.parse(geloeschtAm) + tage * TAG_MS);
}

export const abgelaufen = (geloeschtAm: string, jetzt: Date | number, tage = AUFBEWAHRUNG_TAGE): boolean =>
  geloeschtAm < ablaufGrenze(jetzt, tage);

/**
 * Sind alle Zeilen des aktuellen Stands angekommen? Die Synchronisierung
 * laedt Kopf und Zeilen in Paketen hoch - sie koennen getrennt eintreffen.
 */
export const vollstaendig = (kopf: Pick<PapierkorbEintrag, 'zeilen'>, vorhandeneZeilen: number): boolean =>
  vorhandeneZeilen >= kopf.zeilen;
